import {
  Collection,
  CollectionInfo,
  Links,
  PublicationReaction,
} from "@/store/models";
import UserReaction from "@/store/models/userReaction";
import AbstractSubPublicationsRepository from "./abstractSubPublicationRepository";
import { StandardRepositoryFilters } from "./abstractRepository";
import { isPopulatable } from "@/store/models/abstractModel";

export class UserReactionsFilters extends StandardRepositoryFilters {}

export default class PublicationReactionsRepository extends AbstractSubPublicationsRepository<PublicationReaction> {
  constructor() {
    super({
      subject: "TribeInformationPublications",
      endpoint: "{id}/reactions",
      type: "publications",
      subType: "reactions",
      TypeConstructor: PublicationReaction,
    });
  }

  public getUserReactions(
    reactionValue: string,
    filters?: UserReactionsFilters
  ): Promise<Collection<UserReaction>> {
    const urlFilters = filters ? filters.getURLFilters() : "";
    return this.api.client
      .get(`${this.endpoint}/${encodeURIComponent(reactionValue)}${urlFilters}`)
      .then((response) => {
        const data = { ...response.data };
        const embedded = data._embedded
          ? data._embedded["reactions"] || data._embedded["userReactions"] || []
          : [];

        const entries = embedded.map((item: Partial<UserReaction>) => {
          const model = new UserReaction();
          Object.assign(model, item);
          if (isPopulatable(model)) {
            model.populate(item);
          }
          return model;
        });

        return new Collection<UserReaction>(
          entries,
          new CollectionInfo(data.page),
          new Links(data._links),
          (
            collection: Collection<UserReaction>
          ): Promise<Collection<UserReaction>> => {
            if (collection.links.next.href === undefined) {
              return Promise.reject(new Error("No next page"));
            }
            return this.api.client
              .get(collection.links.next.href)
              .then((response) => {
                const nextData = response.data;
                const nextEmbedded = nextData._embedded
                  ? nextData._embedded["reactions"] ||
                    nextData._embedded["userReactions"] ||
                    []
                  : [];
                const nextEntries = nextEmbedded.map(
                  (item: Partial<UserReaction>) => {
                    const model = new UserReaction();
                    Object.assign(model, item);
                    return model;
                  }
                );
                return new Collection<UserReaction>(
                  nextEntries,
                  new CollectionInfo(nextData.page),
                  new Links(nextData._links)
                );
              });
          }
        );
      });
  }
}
